import React from "react";
import { useDispatch } from "react-redux";
import EditReactQuillModel from "../common/EditReactQuillModel";
import { updateEventNews } from "../../redux/actions/admin/eventsAndNewsAction";

const EditEventsNews = ({ id, title, description, startDate, endDate, refreshData }) => {
  const dispatch = useDispatch();

  const formFields = [
    {
      name: "title",
      label: "Title",
      value: title,
      placeholder: "Events & News Title",
    },
    {
      name: "description",
      label: "Description",
      value: description,
      placeholder: "Events & News Description",
    },
  ];

  const formFieldsDates = [
    {
        name: "startDate",
        label: "Start Date",
        value: startDate,
        placeholder: "Start Date",
      },
  
      {
        name: "endDate",
        label: "End Date",
        value: endDate,
        placeholder: "End Date",
      },
  ]

  // Handle the form data update 
  const handleUpdate = async (updatedData) => {
      await dispatch(updateEventNews(id, updatedData));
    refreshData();
  };

  return (
    <>
      <>
        <EditReactQuillModel
          title="Edit Events & News"
          formFields={formFields}
          formFieldsDates={formFieldsDates}
          onSubmit={handleUpdate}
          buttonName="Update Events & News"
          modelTitle="Are you sure you want to edit these events & news?"
          content="Please confirm to apply the changes mode to this events & news."
          okText="Yes, Change"
          cancelText="No, Cancel"
        />
      </>
    </>
  );
};

export default EditEventsNews;
